import * as React from "react";
import type { SnapshotGridField } from "@/modules/snapshots/businessReports.api";
import { getSnapshotGridSortFields } from "@/modules/snapshots/grid/sortAndFilter";

/** Toolbar-facing views of the backend field list: date filter fields, visible column headers, sort and types. */
export const useSnapshotGridFieldMeta = (backendFields: SnapshotGridField[]) => {
  const availableDateFields = React.useMemo(
    () =>
      backendFields
        .filter(field => field.kind === "date")
        .map(field => ({
          key: field.name,
          label: field.name,
          is_date: true,
        })),
    [backendFields],
  );

  const hasDatePrompts = React.useMemo(() => availableDateFields.length > 0, [availableDateFields]);

  const allColumnHeaders = React.useMemo(
    () =>
      backendFields
        .filter(field => !field.is_note)
        .sort((a, b) => a.order - b.order)
        .map(field => field.name),
    [backendFields],
  );

  const sortFields = React.useMemo(() => getSnapshotGridSortFields(allColumnHeaders), [allColumnHeaders]);

  const columnTypes = React.useMemo(
    () => Object.fromEntries(backendFields.map(field => [field.name, field.kind])),
    [backendFields],
  );

  return { availableDateFields, hasDatePrompts, allColumnHeaders, sortFields, columnTypes };
};
